/** Keep a device online until it has missed three expected heartbeats. */
export const isHeartbeatOnline = (
  lastHeartbeatAt: string | null | undefined,
  heartbeatIntervalSeconds: number,
  nowMs = Date.now()
): boolean | null => {
  if (!lastHeartbeatAt) return null;
  const heartbeatMs = new Date(lastHeartbeatAt).getTime();
  if (!Number.isFinite(heartbeatMs)) return null;

  const intervalSeconds = Math.max(15, heartbeatIntervalSeconds);
  const staleAfterMs = Math.max(90, intervalSeconds * 3) * 1000;
  const ageMs = nowMs - heartbeatMs;
  return ageMs >= 0 && ageMs <= staleAfterMs;
};
